import { Grid, TextField } from '@material-ui/core'
import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import { isValid } from 'date-fns';
import { borderRadius } from '@mui/system';

const DynamicInput = ({ fields }) => {
    return (
        <Grid xs={12} className="mbold mt30">
            {
                fields.map((field) => (<>
                    {field?.type == 1 && <TextComponent data={field} />}
                    {field?.type == 2 && <DatePickerComponent data={field} />}
                    {field?.type == 3 && <DropDownComponent data={field} />}
                    {field?.type == 4 && <TextComponentWithValue data={field} />}
                    {field?.type == 5 && <DatePickerComponentHireDate data={field} />}
                    {field?.type == 6 && <Heading data={field} />}
                    {field?.type == 7 && <Gap />}
                </>))
            }
        </Grid>
    )
}

export default DynamicInput


const TextComponent = ({ data }) => {

    let { name, initial, onChange, isDisabled, message, isRequired, validation, fieldType, maxlength = undefined } = data;

    return (
        <div style={{ marginBottom: "15px" }}>

            <Grid xs={12} className="pl14">{name}</Grid>
            <TextField
                disabled={isDisabled}
                value={initial}
                inputProps={{ maxLength: maxlength }}
                type={fieldType}
                style={{ background: 'white', borderRadius: '10px' }}
                id="outlined-basic"
                errorMessages={['this field is required', 'email is not valid']}
                onChange={(e) => onChange(e.target.value)}
                required={isRequired}
                error={validation ? true : false}
                helperText={validation != false ? validation : ""}
                variant="outlined" className="w100p" />

        </div>)
}

const TextComponentWithValue = ({ data }) => {

    let { name, initial, onChange, isDisabled, message, isRequired, validation, fieldType } = data;

    return (
        <div style={{ marginBottom: "15px" }}>

            <Grid xs={12} className="pl14">{name}</Grid>
            <TextField
                disabled={isDisabled}
                defaultValue={initial}
                value={initial}
                type={fieldType}
                mode={'decimal'}
                style={{ background: 'white', borderRadius: '10px' }}
                id="outlined-basic"
                errorMessages={['this field is required', 'email is not valid']}
                onChange={(e) => onChange(e.target.value)}
                required={isRequired}
                error={validation ? true : false}
                helperText={validation != false ? validation : ""}
                variant="outlined" className="w100p"


            />


        </div>)
}

const DropDownComponent = ({ data }) => {

    let { name, initial, options, onChange, key, isRequired, updateEmergencyContactForm = false } = data;
    return (
        <div style={{ marginBottom: "15px" }}>
            <Grid xs={12} className="pl14">{name}</Grid>
            <Autocomplete
                className="w100p"
                id="combo-box-demo"
                options={options}
                style={{ background: 'white', borderRadius: '10px' }}
                getOptionLabel={(option) => option?.[key]}
                defaultValue={initial}
                value={initial}
                onChange={(e, values) => onChange(values)}
                renderInput={(params) =>
                    <TextField {...params} variant="outlined" defaultValue={initial}
                        required={isRequired}
                    />

                }
            />
        </div>)
}

const DatePickerComponent = ({ data }) => {

    let { name, initial, onChange } = data;

    return (
        <div style={{ marginBottom: "15px" }}>
            <Grid xs={12} className="pl14">{name}</Grid>
            <DatePicker
                value={initial}
                required={true}
                onChange={(value) => onChange(value)}
                id="dob"
                style={{ background: 'white', borderRadius: '10px' }}
                className="datePickerReact w100p bg-white react-date-picker"
                message={'please fill this field'}
                maxDate={new Date("02-29-9999")}

                onCalendarClose={(e) => {
                     
                }}
            />
        </div>
    )
}




















const DatePickerComponentHireDate = ({ data }) => {

    let { name, initial, onChange } = data;

    return (
        <div style={{ marginBottom: "15px", height: '250px' }}>
            <Grid xs={12} className="pl14">{name}</Grid>
            <DatePicker
                value={initial}
                required={true}
                onChange={(value) => onChange(value)}
                id="dob"
                style={{ background: 'white', borderRadius: '10px' }}
                className="datePickerReact w100p bg-white react-date-picker"
                message={'please fill this field'}
                maxDate={new Date("02-29-9999")}

                onCalendarClose={(e) => {
                     
                }}
            />
        </div>
    )
}

const Heading = ({ data }) => {
    let { heading } = data
    return <Grid xs={12} style={{ fontSize: "17px ", fontWeight: "bold", marginTop: "30px", marginBottom: "10px" }} className="">{heading}</Grid>
}

const Gap = () => {
    return <Grid xs={12} className=""></Grid>
}



